import { AnchorProvider, Program } from "@coral-xyz/anchor";
import type { Connection } from "@solana/web3.js";
import { PublicKey } from "@solana/web3.js";

import type { StepRewardPoolIDL } from "../../../models/step/farms/gen/step_reward_pool";
import { StepRewardPoolJSON } from "../../../models/step/farms/gen/step_reward_pool";
import type { Wallet } from "../../../types/wallet";
import { CONFIRM_OPTIONS } from "../../../utils/network";

export const getStepRewardProvider = (connection: Connection, wallet: Wallet): AnchorProvider =>
  new AnchorProvider(connection, wallet, CONFIRM_OPTIONS);

export const getStepRewardProgram = (provider: AnchorProvider): Program<StepRewardPoolIDL> =>
  new Program(StepRewardPoolJSON, new PublicKey(StepRewardPoolJSON.metadata.address), provider);
